import React from "react";
import "./Header.css";
import FileLoaderButton from "./FileLoaderButton";
import PreviewUnlockButton from "./PreviewUnlockButton";
import {useStores} from "../hooks/useStores";
import { observer } from "mobx-react-lite";


const Header = observer(props => {
    const {ImageStore} = useStores();
    return <header className="Header">
        <FileLoaderButton></FileLoaderButton>
        {ImageStore.previewImageLocked && 
            <React.Fragment>
                <PreviewUnlockButton></PreviewUnlockButton>
                <input type="text" className="Header-filename" value={ImageStore.previewImage.key || ""} />
            </React.Fragment>
        }
    </header>;

});
export default Header;